import ScrollReveal from '@/components/base/ScrollReveal';

export default function FinalCTA() {
  return (
    <section id="final-cta" className="relative bg-white py-20 md:py-32" data-product-shop>
      <div className="mx-auto max-w-[800px] px-6 md:px-10 text-center">
        <ScrollReveal>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-6 leading-tight">
            Empieza hoy a crear anuncios de mayor impacto con{' '}
            <span className="text-gradient-red">Inteligencia Artificial</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <p className="text-foreground-500 text-base md:text-lg max-w-xl mx-auto mb-10">
            Únete a cientos de profesionales que ya usan estos prompts para ahorrar tiempo, generar mejores ideas y vender más.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="text-4xl md:text-5xl font-bold text-foreground-950">$7.9 USD</span>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.3}>
          <a
            href="https://wa.link/em25v1"
            className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-primary-500 text-white font-semibold text-lg hover:bg-primary-600 transition-all duration-300 shadow-[0_8px_30px_rgba(229,57,53,0.3)] hover:shadow-[0_12px_40px_rgba(229,57,53,0.4)] hover:-translate-y-1 whitespace-nowrap"
          >
            Descargar Ahora
            <i className="ri-download-line" />
          </a>
        </ScrollReveal>

        <ScrollReveal delay={0.4}>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-time-line text-primary-500" />
              Descarga inmediata
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-500" />
              Pago único
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-infinity-line text-primary-500" />
              Acceso de por vida
            </span>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}